import Vue from 'vue';
import VueI18n from 'vue-i18n';
import bg from '@/dictionaries/bg.js';
import cz from '@/dictionaries/cz.js';
import hu from '@/dictionaries/hu.js';
import pl from '@/dictionaries/pl.js';
import ro from '@/dictionaries/ro.js';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'hu',
  fallbackLocale: 'hu',
  messages: {
    // bg,
    cz,
    hu,
    // pl,
    ro,
  },
});
